// src/component/service/BookmarkButton.jsx
import React from "react";
import { useBookmarkToggle } from "../../viewmodels/useBookmarkViewModel.ts";

export default function BookmarkButton({ uuid, className = "", transparent = false }) {
  const { isBookmarked, isToggling, toggle } = useBookmarkToggle(uuid);

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        toggle();
      }}
      disabled={isToggling}
      aria-label={isBookmarked ? "Remove bookmark" : "Add bookmark"}
      className={[
        "inline-flex items-center justify-center rounded-full w-9 h-9",
        !transparent && "bg-white/90 border border-border-tertiary shadow-sm",
        "transition active:scale-95",
        isToggling ? "opacity-50 cursor-not-allowed" : "hover:opacity-80",
        className,
      ].filter(Boolean).join(" ")}
    >
      <span
        className={[
          "material-symbols-outlined text-[20px] leading-none",
          isBookmarked ? "text-icon-accentOrange" : "text-text-tertiary",
        ].join(" ")}
        style={{ fontVariationSettings: isBookmarked ? "'FILL' 1" : "'FILL' 0" }}
      >
        bookmark
      </span>
    </button>
  );
}
